export default "__VITE_ASSET__$rL9xqw9__"